// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Tooltip_size_m .Tooltip-Content{padding:var(--tooltip-size-m-content-spaceAll);font-size:var(--tooltip-size-m-fontSize);line-height:var(--tooltip-size-m-lineHeight)}.Tooltip_size_m .Popup2-Tail{width:var(--tooltip-size-m-tail-size);height:var(--tooltip-size-m-tail-size)}", ""]);
// Exports
module.exports = exports;
